import PantallaIndiceFlipped from './pantalla-indice-flipped'
export default PantallaIndiceFlipped